import { cloneDeep } from "lodash";

import { Role } from "@/acl/roles";
import { GenericProductCards } from "@/assets/constants/analysisCards";
import { GLOBAL_EVENTS } from "@/assets/constants/eventsDates";
import { UpdateFrequency } from "@/assets/constants/frequencies";
import { STANDARD_PERF_STATS_WITHOUT_BENCHMARK } from "@/assets/constants/perfStats";
import { STANDARD_ZOOM_BUTTONS } from "@/assets/constants/zoomButtons";
import exports from "@/assets/scss/exports.module.scss";

const ORG_COLOR = exports["colors-primary"];
const INTERNAL_ALLOWED_ROLES = [Role.admin, Role.superAdmin];

// ******---------- Mercury ----------*****
const mercury = {
  productId: "mercury",
  storeModule: "mercury",
  productName: "Mercury",
  productColor: ORG_COLOR,
  withoutOverview: true,
  withoutAnalysis: true,
  live: {
    updateFrequency: UpdateFrequency.weekly,
    zoomButtons: STANDARD_ZOOM_BUTTONS,
    genericCardsToShow: [
      GenericProductCards.cumulativeReturns,
      GenericProductCards.performanceStats,
      GenericProductCards.drawdowns,
      GenericProductCards.volatility,
    ],
    perfStats: STANDARD_PERF_STATS_WITHOUT_BENCHMARK,
    events: GLOBAL_EVENTS,
  },
  reports: [
    {
      id: "factsheet",
      langToName: { en: "Factsheet", fr: "Factsheet" },
      allowedRoles: INTERNAL_ALLOWED_ROLES,
    },
  ],
};

// ******---------- Gemini ----------*****
const gemini = {
  productId: "gemini",
  storeModule: "gemini",
  productName: "Gemini",
  productColor: ORG_COLOR,
  withoutOverview: true,
  withoutAnalysis: true,
  live: {
    updateFrequency: UpdateFrequency.weekly,
    zoomButtons: STANDARD_ZOOM_BUTTONS,
    genericCardsToShow: [
      GenericProductCards.cumulativeReturns,
      GenericProductCards.performanceStats,
    ],
    perfStats: STANDARD_PERF_STATS_WITHOUT_BENCHMARK,
    events: GLOBAL_EVENTS,
  },
  reports: [
    {
      id: "factsheet",
      langToName: { en: "Factsheet", fr: "Factsheet" },
      allowedRoles: INTERNAL_ALLOWED_ROLES,
    },
  ],
};

// ******---------- Hermes ----------*****
const hermes = {
  productId: "hermes",
  storeModule: "hermes",
  productName: "Hermes",
  productColor: ORG_COLOR,
  withoutOverview: true,
  withoutAnalysis: true,
  live: {
    updateFrequency: UpdateFrequency.weekly,
    zoomButtons: STANDARD_ZOOM_BUTTONS,
    genericCardsToShow: [
      GenericProductCards.cumulativeReturns,
      GenericProductCards.performanceStats,
    ],
    perfStats: STANDARD_PERF_STATS_WITHOUT_BENCHMARK,
    events: GLOBAL_EVENTS,
  },
  reports: [
    {
      id: "factsheet",
      langToName: { en: "Factsheet", fr: "Factsheet" },
      allowedRoles: INTERNAL_ALLOWED_ROLES,
    },
  ],
};

export const PRODUCTS_DETAILS = [mercury, gemini, hermes];

export const PRODUCTS = PRODUCTS_DETAILS.map((details) => details.storeModule);
